/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Prev_WeekInputs */

const en_plan_prev_week = /** @type {(inputs: Plan_Prev_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous week`)
};

const de_plan_prev_week = /** @type {(inputs: Plan_Prev_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Woche`)
};

/**
* | output |
* | --- |
* | "Previous week" |
*
* @param {Plan_Prev_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_prev_week = /** @type {((inputs?: Plan_Prev_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Prev_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_prev_week(inputs)
	return en_plan_prev_week(inputs)
});